import { PosDocumentsStepModalComponent } from './../../shared/pos-documents-step-modal/pos-documents-step-modal.component';
import { DocumentsStepComponent } from './../../views/credit-request/components/documents-step/documents-step.component';
import { Injectable } from '@angular/core';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { ModalDialogType } from '../constants';
import { FormGroup, FormArray } from '@angular/forms';

@Injectable({
  providedIn: 'root',
})
export class PosDocumentsStepModalService {
  modalRef:BsModalRef<PosDocumentsStepModalComponent> | undefined;

  constructor(private modalService: BsModalService) {}

  async show(documentsForm: FormArray): Promise<any> {
   this.modalRef = this.modalService.show(PosDocumentsStepModalComponent, {
      class: `modal-dialog modal-lg modal-dialog-scrollable ${ModalDialogType.PRIMARY}`,
      backdrop: true,
      ignoreBackdropClick: true,
      keyboard: false,
      animated: true,
      initialState: {
        documentsForm
      },
    });

    return this.modalRef.content?.attachmentFilesChange.toPromise();
  }
}
